/**
 * Created by commyfeng on 2017/3/17.
 */

import Coa from '@tencent/Coa/index';
import RequestError from '@tencent/Coa/lib/RequestError';
import RequestErrorType from '@tencent/Coa/lib/RequestErrorType';
import { getUrlParam } from '@tencent/vft-common/util';
var baseUrl = '//vip.video.qq.com/fcgi-bin/comm_cgi?otype=json&cmd=1';
var newMagicBaseUrl = '//activity.video.qq.com/fcgi-bin/asyn_activity?otype=json';
var filterRet0 = Coa.filterResponse(function (res) {
  if (res.ret !== 0) {
    try {
      var _window$aegis;
      (_window$aegis = window.aegis) === null || _window$aegis === void 0 ? void 0 : _window$aegis.vWarn({
        tag: 'bookService请求错误[filterRet0]',
        error: res
      });
    } catch (_) {}
    throw new RequestError(res.ret, res.msg, res, RequestErrorType.SYSTEM_ERR);
  }
  return res;
});
export function queryBookStatus(actId) {
  var moduleId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var bookList = '';
  if (Array.isArray(actId)) {
    bookList = actId.map(function (i) {
      return "act_id=".concat(i.actId, "&module_id=").concat(i.moduleId);
    }).join('$');
  } else {
    bookList = "act_id=".concat(actId, "&module_id=").concat(moduleId);
  }
  return Coa(Coa.Retry(1),
  // Coa.Report(),

  filterRet0).run(baseUrl, {
    name: 'act_book_query',
    book_list: bookList
  });
}
export function bookActivity(actId) {
  var moduleId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return Coa(Coa.Retry(1),
  // Coa.Report(),
  filterRet0).run(baseUrl, {
    name: 'act_book_write',
    book_type: 0,
    book_list: "act_id=".concat(actId, "&module_id=").concat(moduleId)
  });
}
export function bookActivityNew(actId, modId) {
  return Coa(filterRet0).run(newMagicBaseUrl, {
    act_id: actId,
    module_id: modId,
    type: '30',
    option: '104',
    is_prepublish: getUrlParam('is_prepublish') || '0'
  });
}
export function queryBookInfoNew(actId, modId) {
  return Coa(filterRet0).run(newMagicBaseUrl, {
    act_id: actId,
    module_id: modId,
    type: '30',
    option: '3',
    is_prepublish: getUrlParam('is_prepublish') || '0'
  });
}
export function cancelBookActivity(actId) {
  var moduleId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return Coa(Coa.Retry(1),
  // Coa.Report(),
  filterRet0).run(baseUrl, {
    name: 'act_book_write',
    book_type: 1,
    book_list: "act_id=".concat(actId, "&module_id=").concat(moduleId)
  });
}